import Vue from "vue";
import App from "./App.vue";
import VueFullPage from "vue-fullpage.js";
import "normalize.css";
import vuetify from './plugins/vuetify';
import '@mdi/font/css/materialdesignicons.css'

Vue.use(VueFullPage);
Vue.config.productionTip = false;

new Vue({
  vuetify,
  render: h => h(App)
}).$mount("#app");
